export * from './contentTypes';
export * from './headers';
export * from './statusCodes';
export const DEFAULT_TIMEOUT = 5000;
//# sourceMappingURL=index.js.map